<template>
    <div v-if="this.show" class="overlay">
        <div>
            <div class="modal_box wd720">
                <div class="modal_header_unit">
                    <div class="modal_header_box">
                        <p class="modal_header_tit">{{this.title}}</p>
                    </div>
                    <div v-if="this.button.cancel.show" class="modal_header_left">
                        <a class="js-modal-close" href="#" role="button" @click.stop.prevent="dismiss()">{{this.button.cancel.text}}</a>
                    </div>
                </div>
                <div class="modal_content_tex">
                    <p class="text_white_space_pre_wrap">{{this.text}}</p>
                </div>
                <div v-if="this.button.done.show" class="btn_submit">
                    <a href="#" role="button" @click.stop.prevent="done()">{{this.button.done.text}}</a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'Dialog',
        computed: {
                title() {
                    return this.$store.getters['dialog/title']
                },
                text() {
                    return this.$store.getters['dialog/text']
                },
                button() {
                    return this.$store.getters['dialog/button']
                },
                next() {
                    return this.$store.getters['dialog/next']
                },
                show() {
                    return this.$store.getters['dialog/show']
                }
        },
        methods: {
            dismiss: function () {
                this.$store.dispatch('dialog/dismiss')
            },
            done: function () {
                this.dismiss()
                if (this.next) {
                    this.$router.push(this.next)
                }
            }
        },
    }
</script>
